// Modules
import Korg from 'reed-korg'


// Components
import BaseComponent from '@blocks/_BaseComponent'
import gsap from 'gsap'



/* MENU
----------------------------------------------------------------------------------------------------*/

export default class Menu extends BaseComponent {

    constructor($el) {
        super('Menu', $el, '.global')

        this.createTimeline()
        this.on()
    }

    bindProperties() {
        this.isOpen = false
        this.korg = new Korg(this.$refs.scrollArea[0])
    }


    bindHandlers() {
        this.clickHandler          = (e) => { this.onButtonClick(e) }
        this.pageWillChangeHandler = () => { this.onPageWillChange() }
        this.pageChangeEndHandler  = () => { this.onPageChangeEnd() }
        this.resizeHandler         = () => { this.onResize() }
        this.scrollHandler         = () => { this.onScroll() }
    }


    bindEvents() {
        const { $doc, $win } = this.$utils
        const { $menuBtn } = this.$refs

        this.addListeners(
            // Layout events
            [$doc, 'layoutChange', this.resizeHandler],
            [$win, 'scroll', this.scrollHandler],

            // User input
            [$menuBtn, 'click', this.clickHandler],
        )
    }


    /* Init
    --------------------------------------------------------- */

    createTimeline() {
        const { headerH } = APP.Layout

        this.stickyTL = gsap.timeline({
            scrollTrigger: {
                trigger: '.view',
                start: () => (APP.Layout.isScrollingDown ? window.scrollY : Math.max(0, window.scrollY - headerH * 2)),
                end: `+=${headerH * 2}`,
                scrub: true,
                invalidateOnRefresh: true,
            },
        })

        this.stickyTL.fromTo(document.documentElement, { '--navOffset': 0 }, { '--navOffset': 1, ease: 'none' })
    }


    /* Handlers
    --------------------------------------------------------- */

    onPageWillChange() {
        //
    }


    onPageChangeEnd() {
        this.forceCloseMenu()
    }


    onResize() {
        if (!this.isOpen || !APP.Layout.isDesktop) return

        this.forceCloseMenu()
    }


    onScroll() {
        const isSticky = window.scrollY >= APP.Layout.headerH * 2
        this.$el.toggleClass('is-sticky', isSticky)


        this.manageStickyState()
    }


    onButtonClick(e) {
        e.preventDefault()

        this.toggleMenu()
    }



    /* Actions
    --------------------------------------------------------- */

    toggleMenu(shouldOpen = !this.isOpen) {
        if (shouldOpen === this.isOpen) return
        const { $doc, $body } = this.$utils

        this.isOpen = shouldOpen
        this.korg.toggle(this.isOpen)

        if (shouldOpen) {
            this.$refs.scrollArea[0].scrollTop = 0
        }

        $body.toggleClass('menu-open', this.isOpen)
        $doc.trigger('menuToggled', { isOpen : this.isOpen })
    }


    forceCloseMenu() {
        this.toggleMenu(false)
    }


    manageStickyState() {
        if (APP.Layout.isScrollingDown === APP.Layout.wasScrollingDown) return

        const previousProgress = this.stickyTL.progress()
        const isAtBounds       = previousProgress > 0 && previousProgress < 1


        if (isAtBounds) return

        this.stickyTL.invalidate()
        this.stickyTL.progress(previousProgress)
        this.stickyTL.scrollTrigger.refresh()
    }


    /* Values
    --------------------------------------------------------- */

}




/* CONSTANTS AND HELPERS
---------------------------------------------------------------------------------------------------- */



